module.exports = __webpack_public_path__ + "static/media/savvy-ipld-explorer.397aba4d.svg";